import { render, staticRenderFns } from "./ProjectTenant.vue?vue&type=template&id=2a5bf3ab&scoped=true&"
import script from "./ProjectTenant.vue?vue&type=script&lang=js&"
export * from "./ProjectTenant.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTenant.vue?vue&type=style&index=0&id=2a5bf3ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5bf3ab",
  null
  
)

export default component.exports